(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-description"] && !Shopify.designMode) return;
  try {
    class ProductDescriptionTruncate extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-pd-content]');
      this.toggle = this.querySelector('[data-pd-toggle]');
      this.moreLabel = this.querySelector('[data-pd-more]');
      this.lessLabel = this.querySelector('[data-pd-less]');
      if (!this.content || !this.toggle) return;

      if (!this.bound) {
        this.toggle.addEventListener('click', () => this.onToggle());
        this.resizeHandler = this.debounce(() => this.evaluate(), 200);
        window.addEventListener('resize', this.resizeHandler);
        this.bound = true;
      }

      requestAnimationFrame(() => this.evaluate());
    }

    disconnectedCallback() {
      if (this.resizeHandler) window.removeEventListener('resize', this.resizeHandler);
    }

    getCollapsedPx() {
      const fontSize = parseFloat(getComputedStyle(this.content).fontSize) || 16;
      const raw = getComputedStyle(this).getPropertyValue('--pd-collapsed-height');
      const em = parseFloat(raw) || 8;
      return em * fontSize;
    }

    evaluate() {
      const fullHeight = this.content.scrollHeight;
      const collapsedPx = this.getCollapsedPx();
      const needsTruncation = fullHeight > collapsedPx + 4;

      this.toggle.hidden = !needsTruncation;

      if (!needsTruncation) {
        this.removeAttribute('data-collapsed');
      } else if (!this.userControlled) {
        this.setAttribute('data-collapsed', '');
      }
      this.syncLabels();
    }

    onToggle() {
      this.userControlled = true;
      if (this.hasAttribute('data-collapsed')) {
        this.removeAttribute('data-collapsed');
      } else {
        this.setAttribute('data-collapsed', '');
      }
      this.syncLabels();
    }

    syncLabels() {
      const collapsed = this.hasAttribute('data-collapsed');
      this.toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      if (this.moreLabel) this.moreLabel.hidden = !collapsed;
      if (this.lessLabel) this.lessLabel.hidden = collapsed;
    }

    debounce(fn, wait) {
      let timer;
      return () => {
        clearTimeout(timer);
        timer = setTimeout(fn, wait);
      };
    }
  }

  if (!customElements.get('product-description-truncate')) {
    customElements.define('product-description-truncate', ProductDescriptionTruncate);
  }
  } catch(e) { console.error(e); }
})();

})();
